import type { RequestPolicy, RequestPolicyFactory, RequestPolicyOptions } from '@azure/ms-rest-js';

import { CustomHeaderPolicy } from './CustomHeaderPolicy';

const headerName = 'x-tenant-context';

export const tenantPolicy = (tenant: string): RequestPolicyFactory => ({
    create: (nextPolicy: RequestPolicy, options: RequestPolicyOptions): RequestPolicy =>
        new CustomHeaderPolicy(nextPolicy, options, headerName, tenant),
});
